import mergeWith from 'lodash.mergewith'

const initialState = {
  albums: {},
  playlists: {},
  queues: {},
  images: {},
  users: {}
}

export default function reducer (state = initialState, action = {}) {
  const { payload } = action
  if (payload && payload.entities) {
    return mergeWith({}, state, payload.entities, customizer)
  }
  return state
}

function customizer (obj, src, key) {
  // Merging a longer perms array with a smaller one will return the long array
  // but we may want to shorten perms, so just return the new one
  if (key === 'perms' || key === 'libraries') {
    return src
  }
  // Fix weirdness when merging keyword graph nodes
  if (key === 'children') {
    return src
  }
  return undefined
}



// WEBPACK FOOTER //
// ./src/redux/entities.js